<template>
  <RolePermissions
    v-if="params"
    :getUrl="`permissions/user-permissions/${params}`"
    :submitUrl="`permissions/user-permission-assign/${params}/`"
    :hasRoleId="false"
  />
</template>
<script>
import RolePermissions from "@/views/permission/RolePermissions";

export default {
  components: {RolePermissions},
  data() {
    return {
      params: this.$route.params.id
    }
  },
  mounted() {
    // if (this.$route && this.$route.params)
    //   this.params = this.$route.params.id
  }
};
</script>


<!--<template>-->
<!--  <vx-card title="Permissions">-->
<!--    <template v-if="skeleton">-->
<!--      <a-skeleton v-for="n in 5" active avatar />-->
<!--    </template>-->
<!--    <template v-else>-->
<!--      <a-tree-->
<!--        checkable-->
<!--        :tree-data="permissions"-->
<!--        :default-checked-keys="defaultPermission"-->
<!--        @select="onSelect"-->
<!--        @check="onCheck"-->
<!--      />-->
<!--      <a-button type="primary" :loading="loading" class="mt-10" @click="handleRolePermission" style="border-radius: 3px !important;">Save</a-button>-->
<!--    </template>-->
<!--  </vx-card>-->
<!--</template>-->
<!--<script>-->
<!--import axios from '@/axios'-->
<!--import mixin from '@/views/mixin/mixin'-->

<!--export default {-->
<!--  mixins: [mixin],-->
<!--  data() {-->
<!--    return {-->
<!--      skeleton: false,-->
<!--      loading: false,-->
<!--      permissions: [],-->
<!--      defaultPermission: []-->
<!--    };-->
<!--  },-->
<!--  methods: {-->
<!--    onSelect(selectedKeys) {-->
<!--      console.log('selected', selectedKeys);-->
<!--    },-->
<!--    onCheck(checkedKeys) {-->
<!--      this.defaultPermission = checkedKeys-->
<!--    },-->
<!--    async getAllPermissions () {-->
<!--      try {-->
<!--        this.skeleton     = true-->
<!--        const { data }   = await axios.get('permissions/')-->
<!--        const permissions = await axios.get(`permissions/user-permissions/${this.$route.params.id}`)-->
<!--        const dataSource = [...new Set(data)]-->
<!--        const myPermission = permissions.data.map(({permission}) => permission)-->
<!--        this.defaultPermission = dataSource.filter(item => myPermission.includes(item))-->
<!--        // labels permission-->
<!--        const labelsMatter  = ['matter list','matter details','matter creation','matter edit','delete matter','matter report']-->
<!--        const labelsTask    = ['task list','task details','task creation','task edit','delete task','task report']-->
<!--        const labelsContact = ['contact list','contact details','contact creation','contact edit','contact note','delete contact','contact report']-->
<!--        const labelsNote    = ['note list','note details','note creation','edit note','delete note']-->
<!--        const labelDocument = ['document list','document details','document creation','edit document','delete document']-->
<!--        const labelActivity = ['time list','expense list','category list','time details','expense details','category details','time creation','expense creation','category creation','time edit','expense edit','category edit','time delete','expense delete','category delete']-->
<!--        const labelCalender = ['event list','event details','event creation','edit event','delete event']-->
<!--        const labelAccount  = ['account list','account details','account creation','account edit','account delete','account deposit','account transfer','account withdraw','account transaction']-->
<!--        const labelBilling  = ['billing list','billing details','billing creation','billing edit','billing delete','fund list','fund send','fund html','fund pdf','billing payment','fund detail','fund create','fund edit','fund delete','billing report','billing report revenue']-->
<!--        const labelCommunication = ['communication email list','communication email details','communication email creation','communication email edit','delete communication email','communication call list','communication call details','communication call creation','communication  call edit','communication call delete']-->
<!--        const labelSetting  = ['edit system setting','edit personal setting','edit web setting']-->
<!--        // filter split permission-->
<!--        const matters    = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'matter'-->
<!--        })-->
<!--        const tasks      = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'task'-->
<!--        })-->
<!--        const contacts   = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'contact'-->
<!--        })-->
<!--        const notes      = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'note'-->
<!--        })-->
<!--        const documents  = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'document'-->
<!--        })-->
<!--        const events     = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'calendar'-->
<!--        })-->
<!--        const times      = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'activity'-->
<!--        })-->
<!--        const account    = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'bank-account'-->
<!--        })-->
<!--        const billing    = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'billing'-->
<!--        })-->
<!--        const communication = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'communication'-->
<!--        })-->
<!--        const setting    = dataSource.filter((word) => {-->
<!--          const a = word.split('.')-->
<!--          return a[0] === 'Setting'-->
<!--        })-->
<!--        // make objects-->
<!--        const matterChild   = {-->
<!--          title: 'Matter',-->
<!--          key:'Matter',-->
<!--          children: matters.map((item,i) => ({ key: item, title: labelsMatter[i]  }))-->
<!--        }-->
<!--        const taskChild     = {-->
<!--          title: 'Task',-->
<!--          key  : 'Task',-->
<!--          children: tasks.map((item,i) => ({ key: item, title: labelsTask[i] }))-->
<!--        }-->
<!--        const contactChild  = {-->
<!--          title: 'Contact',-->
<!--          key  : 'Contact',-->
<!--          children: contacts.map((item,i) => ({ key: item, title: labelsContact[i] }))-->
<!--        }-->
<!--        const noteChild     = {-->
<!--          title: 'Note',-->
<!--          key  : 'Note',-->
<!--          children: notes.map((item,i) => ({ key: item, title: labelsNote[i] }))-->
<!--        }-->
<!--        const docChild      = {-->
<!--          title: 'Documents',-->
<!--          key  : 'Documents',-->
<!--          children: documents.map((item,i) => ({ key: item, title: labelDocument[i] }))-->
<!--        }-->
<!--        const eventChild    = {-->
<!--          title: 'Calender',-->
<!--          key  : 'calender',-->
<!--          children: events.map((item,i) => ({ key: item, title: labelCalender[i] }))-->
<!--        }-->
<!--        const timesChild    = {-->
<!--          title: 'Activity',-->
<!--          key  : 'activity',-->
<!--          children: times.map((item,i) => ({ key: item, title: labelActivity[i] }))-->
<!--        }-->
<!--        const accountChild  = {-->
<!--          title: 'Account',-->
<!--          key  : 'Account',-->
<!--          children: account.map((item,i) => ({ key: item, title: labelAccount[i] }))-->
<!--        }-->
<!--        const billingChild  = {-->
<!--          title: 'billing',-->
<!--          key  : 'billing',-->
<!--          children: billing.map((item,i) => ({ key: item, title: labelBilling[i] }))-->
<!--        }-->
<!--        const communicationChild = {-->
<!--          title: 'communication',-->
<!--          key  : 'communication',-->
<!--          children: communication.map((item,i) => ({ key: item, title: labelCommunication[i] }))-->
<!--        }-->
<!--        const settingChild  = {-->
<!--          title: 'Setting',-->
<!--          key  : 'setting',-->
<!--          children: setting.map((item,i) => ({ key: item, title: labelSetting[i] }))-->
<!--        }-->
<!--        // list finally-->
<!--        this.permissions = [-->
<!--          matterChild,-->
<!--          taskChild,-->
<!--          contactChild,-->
<!--          timesChild,-->
<!--          noteChild,-->
<!--          docChild,-->
<!--          eventChild,-->
<!--          accountChild,-->
<!--          billingChild,-->
<!--          communicationChild,-->
<!--          settingChild-->
<!--        ]-->
<!--      }catch (e) {-->
<!--        this.$message.error('Server Error')-->
<!--        throw new Error(e)-->
<!--      }finally {-->
<!--        this.skeleton = false-->
<!--      }-->
<!--    },-->
<!--    async handleRolePermission() {-->
<!--      if (this.$route.params.id) {-->
<!--        try {-->
<!--          this.loading = true-->
<!--          await axios.post(`permissions/user-permission-assign/${this.$route.params.id}/`,{ permissions: this.defaultPermission })-->
<!--          this.$message.success('Permission granted.')-->
<!--        }catch (e) {-->
<!--          this.$message.success('Error applying permission.')-->
<!--          throw new Error(e)-->
<!--        }finally {-->
<!--          this.loading = false-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  },-->
<!--  mounted() {-->
<!--    this.getAllPermissions()-->
<!--  }-->
<!--};-->
<!--</script>-->
